import { useApi, apiResolver } from "@/api/useApi";
import { EscalationRule } from "./EscalationRule.model";
import { useMemo } from "react";

type GetEscalationRulesResponse = {
  id: string;
  name: string;
  topics: string[];
}[];

export type CreateEscalationRuleRequest = Omit<EscalationRule, "id">;

export type TicketFieldsClientResponse = {
  id: string;
  name: string;
  customFieldOptions: {
    id: number;
    name: string;
    value: string;
  }[];
};

export function useEscalationRuleApi(simulatorId?: string) {
  const { api } = useApi();
  const suffix = useMemo(() => {
    return simulatorId ? `?simulatorId=${simulatorId}` : "";
  }, [simulatorId]);
  const endpoint = useMemo(() => {
    return `/sessions-api/quackchat-config/escalation-rules`;
  }, [simulatorId]);

  return {
    getEscalationRules: async () =>
      apiResolver<GetEscalationRulesResponse>(api.get(endpoint + suffix)),
    getEscalationRule: async (escalationRuleId: string) =>
      apiResolver<EscalationRule>(
        api.get(`${endpoint}/${escalationRuleId}${suffix ? `${suffix}` : ""}`)
      ),
    createEscalationRule: async (escalationRule: CreateEscalationRuleRequest) =>
      apiResolver<EscalationRule>(
        api.post(
          `/sessions-api/quackchat-config/escalation-rule`,
          escalationRule
        )
      ),
    updateEscalationRule: async (escalationRule: EscalationRule) =>
      apiResolver<EscalationRule>(
        api.put(`${endpoint}/${escalationRule.id}`, escalationRule)
      ),
    deleteEscalationRule: async (escalationRuleId: string) =>
      apiResolver<void>(api.delete(`${endpoint}/${escalationRuleId}`)),
    getLiveAgentAvailability: async (tenantId: string) =>
      apiResolver<boolean>(
        api.get(
          `/sessions-api/quackchat-config/tenants/${tenantId}/live-agent-supported`
        )
      ),
    getTicketFields: async () =>
      apiResolver<TicketFieldsClientResponse[]>(
        api.get(`/sessions-api/quackchat-config/ticket-fields`)
      ),
  };
}
